import React, { useEffect, useState } from "react";
import { CampaignViewDetailsViewCampaignsInfoProps } from "./campaign-view-details-view-campaigns-info.props";
import "./campaign-view-details-view-campaigns-info.scss";
import CloseIcon from "@mui/icons-material/Close";
import { deleteCampaignAssign, editCampaignStatus, getCampaignDetails } from "../../../../../../api/campaign";
import { IconButton } from "@mui/material";
import DataTable from "../campaign-view-details-view-activities-info/task-table/task-table";
import CrossIcon from "../../../../../../assets/icons/cross-icon.svg";
import ConfirmInfo from "../../../../../../assets/icons/confirm-info.svg";
import { ConfirmationPopup } from "../../../../../../common/components";
import { Checkbox } from "@mui/material";
import StatusDialog from "./status-dialog/update-status-dialog";
import AddCustomerList from "./add-customer-modal/add-customer-list";
import AddToCampaignModal from "../campaign-view-details-view-leads-info/add-new-campaign/add-new-campiagn";
import { isValidPhoneNumber } from "../../../../../../utils/utils";

const CampaignViewDetailsViewContactInfo: React.FC<
  CampaignViewDetailsViewCampaignsInfoProps
> = (props: any) => {
  const {
    allCampaignData,
    setLoading,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    permissions,
  } = props;
  const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
  const [campiagnDetails, setCampaignDetails] = useState<any>(null);
  const [campiagnName, setCampiagnName] = useState("");
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [selectedCustomerIds, setSelectedCustomerIds] = useState<number[]>([]);
  const [campaignToDelete, setCampaignToDelete] = useState<{
    customerId: number;
    associationId: number;
    customerName: string;
  } | null>(null);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [statusFilter, setStatusFilter] = useState("Planned");
  const [selectedAssociationIds, setSelectedAssociationIds] = useState<
    number[]
  >([]);
  const [isCampaignModalOpen, setIsCampaignModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsCustomerModalOpen(false);
  };
  const handleSaveStatus = async () => {
    if (selectedCustomerIds.length === 0) return;
    setLoading(true);
    try {
      const response = await editCampaignStatus(
        statusFilter,
        selectedAssociationIds,
        "View Campaigns"
      );
      setAlertMessage("Campaign Status Updated Successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchCampaignDetails();
      setSelectedCustomerIds([]); // Clear selection after update
    } catch (error) {
      setAlertMessage("Failed to update campaign status.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
      setOpenStatusDialog(false);
    }
  };

  const confirmDeleteCampaign = async () => {
    if (!campaignToDelete) return;
    setLoading(true);
    try {
      await deleteCampaignAssign(
        campaignToDelete.customerId,
        campaignToDelete.associationId,
        "View Campaigns"
      );
      setAlertMessage("Campaign unassigned successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchCampaignDetails();
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to unassign campaign."
      );
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
      setIsArchivePopupOpen(false);
      setCampaignToDelete(null);
    }
  };
  const fetchCampaignDetails = async () => {
    setLoading(true);
    try {
      const response = await getCampaignDetails(allCampaignData);
      const campaignData = response?.data?.data;
      setSelectedCustomerIds([]);
      setSelectedAssociationIds([]);
      setCampiagnName(campaignData?.name);
      setCampaignDetails(
        (response?.data?.data?.CampaignCustomerAssociation || []).map(
          (item: any) => ({
            ...item.customer,
            membership_status: item.customer_status_in_campaign,
            campaign_customer_association_id: item.id,
          })
        )
      );
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while saving the customer."
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCampaignDetails();
  }, [allCampaignData, isCustomerModalOpen]);
  const customerColumns = [
    {
      key: "customerName",
      label: "Customer Name",
      render: (customer: any) =>
        `${customer?.first_name} ${customer?.middle_name || ""} ${customer?.last_name || ""}`,
    },
    {
      key: "email",
      label: "Email",
      render: (customer: any) => customer?.primary_email_address || "-",
    },
    {
      key: "phoneNumber",
      label: "Phone Number",
      render: (customer: any) =>
        isValidPhoneNumber(customer?.primary_phone_number)
          ? customer?.primary_phone_number
          : "-",
    },
    {
      key: "source",
      label: "Lead Source",
      render: (customer: any) => customer?.lead_source || "-",
    },
    {
      key: "company",
      label: "Company",
      render: (customer: any) => customer?.company || "-",
    },
    {
      key: "membership",
      label: "Member Status",
      render: (customer: any) => customer?.membership_status || "-",
    },
  ];
  return (
    <div className="campaign-view-details-view-campaigns-info">
      <div className="campaign-view-details-view-campaigns-info-header">
        <div className="campaign-view-details-view-campaigns-info-header-text">
          Customers
        </div>
        <div>
          {selectedCustomerIds.length > 0 ? (
            <div className="action-bar">
              <button
                className="campaign-view-details-view-campaigns-info-header-button"
                onClick={() => setIsCampaignModalOpen(true)}
              >
                Campaigns
              </button>

              <button
                className="campaign-view-details-view-campaigns-info-header-button"
                onClick={() => {
                  setOpenStatusDialog(true);
                }}
              >
                Update Member Status
              </button>
            </div>
          ) : (
            <button
              className="campaign-view-details-view-campaigns-info-header-button"
              onClick={() => setIsCustomerModalOpen(true)}
            >
              Add Customer
            </button>
          )}
        </div>
      </div>

      {isCustomerModalOpen && (
        <div className="modal-overlay">
          <button className="close-button" onClick={handleCloseModal}>
            <CloseIcon sx={{ fontSize: "15px" }} />
          </button>
          <div className="modal-content">
            <AddCustomerList
              allCampaignData={allCampaignData}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              handleCloseModal={handleCloseModal}
              campaignName={campiagnName}
            />
          </div>
        </div>
      )}
      {campiagnDetails && campiagnDetails.length > 0 ? (
        <div className="campaign-leads-table">
          <DataTable
            key={JSON.stringify(selectedCustomerIds)}
            columns={customerColumns}
            data={campiagnDetails}
            rowActions={(customer) => (
              <div
                style={{ display: "flex" }}
                className={`${!permissions?.canWrite ? "Mui-disabled" : ""}`}
              >
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setCampaignToDelete({
                      customerId: customer?.id,
                      associationId: customer?.campaign_customer_association_id,
                      customerName: `${customer.first_name} ${customer.middle_name || ""} ${customer.last_name}`,
                    });
                    setIsArchivePopupOpen(true);
                  }}
                  className="icon-button"
                  disabled={!permissions?.canWrite}
                >
                  <img src={CrossIcon} alt="done" className="img-icon" />
                </IconButton>
                <Checkbox
                  size="small"
                  color="primary"
                  checked={selectedCustomerIds.includes(customer.id)}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setSelectedCustomerIds((prev) =>
                      isChecked
                        ? [...prev, customer.id]
                        : prev.filter((id) => id !== customer.id)
                    );
                    setSelectedAssociationIds((prev) =>
                      isChecked
                        ? [...prev, customer.campaign_customer_association_id]
                        : prev.filter(
                            (id) => id !== customer.campaign_customer_association_id
                          )
                    );
                  }}
                  disabled={!permissions?.canWrite}
                />
              </div>
            )}
          />
        </div>
      ) : (
        <div className="campaign-view-details-view-campaigns-info-no-data">
          No records found.
        </div>
      )}
      <div className="mark-completed">
        <ConfirmationPopup
          open={isArchivePopupOpen}
          onCancel={() => {
            setIsArchivePopupOpen(false);
            setCampaignToDelete(null);
          }}
          onOkay={confirmDeleteCampaign}
          title="Unassign Customer"
          note={`Unassign ${campaignToDelete?.customerName} from ${campiagnName} Campaign`}
          buttonText="Confirm"
          Icon={ConfirmInfo}
          className="mark-completed-confirmation"
        />
      </div>
      <StatusDialog
        open={openStatusDialog}
        onClose={() => setOpenStatusDialog(false)}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        handleSaveStatus={handleSaveStatus}
      />
      <AddToCampaignModal
        leadsIds={Object.values(selectedCustomerIds).flat() || []}
        isOpen={isCampaignModalOpen}
        setMenuItems={() => {}}
        selectedActions={"addToCampaign"}
        handleMassActionMenuClose={() => setIsCampaignModalOpen(false)}
        onSave={async () => {
          setSelectedCustomerIds([]);
          setSelectedAssociationIds([]);
          await fetchCampaignDetails();
          setIsCampaignModalOpen(false);
        }}
        hideAddCampaignButton={true}
        campaignsSection={true}
      />
    </div>
  );
};

export default CampaignViewDetailsViewContactInfo;
